// src/Content/SectionTitles.ts
import { Localized } from "../Types/Localized";
import { Lang } from "../Types/Lang";

export type SectionKey =
  | "aboutMe"
  | "experience"
  | "projects"
  | "education"
  | "competences";

export const sectionTitles: Record<SectionKey, Localized<string>> = {
  aboutMe:     { en: "About Me",     da: "Om mig" },
  experience:  { en: "Experience",   da: "Erfaring" },
  projects:    { en: "Projects",     da: "Projekter" },
  education:   { en: "Education",    da: "Uddannelse" },
  competences: { en: "Competences",  da: "Kompetencer" },
};

// lille helper m. fallback
export const tt = (key: SectionKey, lang: Lang, fb: Lang = "en") =>
  sectionTitles[key][lang] ?? sectionTitles[key][fb];
